<template>
    <section>
        <div class="grid-container">
            <div class="grid-item">
                <welcome :userData="userData" />
                <filtro
                    :isLoading="isLoading"
                    :showExportActions="true"
                    class="mt-3"
                    @buscar="buscar($event)"
                    @export-csv="$emit('export-csv')"
                    @export-excel="$emit('export-excel')"
                    :advanced="true" />
                <totalPatiens class="mt-3" :userData="userData" :dataDashboard="dataDashboard" :fechas="fechas" />
                <ins-base-value
                    class="mt-3"
                    :ins-base-value="insuranceCharts.ins_base_value" />
                <insurance-summations
                    class="mt-3"
                    chart-title="Insurance Summations"
                    :sum-data="insuranceCharts.year_data" />
                <averageClinic class="mt-3" :userData="userData" :dataDashboard="dataDashboard" />
            </div>
            <div class="grid-item">
                <statistics :stadistics="stadistics" />
                <averages class="mt-3" :averages="averages" :dates="fechas" :byType="byType" />
                <statisticsPatients class="mt-3" :userData="userData" :dataDashboard="dataDashboard" />
            </div>
        </div>
    </section>
</template>

<script>
import welcome from '../components/welcome.vue';
import filtro from '../components/filter';
import averageClinic from '../components/averageClinic';
import statisticsPatients from '../components/statisticsPatients';
import statistics from '../components/statistics';
import totalPatiens from '../components/totalPatiens';
import insBaseValue from '../components/insBaseValue.vue';
import insuranceSummations from '@/view/pages/dashboard-insurance/components/summations.vue';
import averages from "../components/averages"
import { getTotalIncome } from '../utils/totals'
import { readDailyAverageValue } from '@/core/utils/dailyAverageFields'

export default {
    components: {
        averages,
        welcome,
        filtro,
        averageClinic,
        statisticsPatients,
        statistics,
        totalPatiens,
        insBaseValue,
        insuranceSummations,
    },
    props: {
        userData: {
            type: Object,
            default: () => { },
            required: false
        },
        dataDashboard: {
            type: Object,
            default: () => { },
            required: false
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        insuranceCharts: {
            type: Object,
            default: () => ({ ins_base_value: null, year_data: [] }),
        },
    },
    data() {
        return {
            stadistics: [],
            averages: [],
            fechas: {
                start: '',
                end: ''
            }
        }
    },
    watch: {
        dataDashboard() {
            this.stadistics = [
                {
                    description: "Average diario del periodo de la fecha selecionada divido en los dias de ese periodo",
                    value: parseInt(this.dataDashboard.average.income_days),
                    title: "Daily Average Income"
                },
                {
                    description: "Average diario del periodo de la fecha selecionada divido en los dias de ese periodo",
                    value: parseInt(this.dataDashboard.average.expenses_days),
                    title: "Daily Average Expenses"
                },
                {
                    description: "(Daily Average Income) - (Daily Average Expences) - (Devolution)",
                    value: parseInt(this.dataDashboard.average.net_income_days),
                    title: "Net Average Income"
                },
                {
                    description: "Suma total del periodo de la fecha selecionada",
                    value: parseInt(getTotalIncome(this.dataDashboard.totals)),
                    title: "Total Income"
                },
                {
                    description: "Suma total  del periodo de la fecha selecionada",
                    value: parseInt(this.dataDashboard.totals.expenses),
                    title: "Total Expenses"
                },
                {
                    description: "(Total Income ) - (Total Expences) - (Devolution)",
                    value: parseInt(this.dataDashboard.totals.net_income),
                    title: "Total net income"
                },
                {
                    description: "Suma total  del periodo de la fecha selecionada En Cash",
                    value: parseInt(this.dataDashboard.cash_cc.cash),
                    title: "Total income cash"
                },
                {
                    description: "Suma total  del periodo de la fecha selecionada en CC",
                    value: parseInt(this.dataDashboard.cash_cc.cc),
                    title: "Total Income CC"
                },
                {
                    description: "Suma total de los montos devueltos por cualquier motivo del periodo de la fecha selecionadaSuma total de los montos devueltos por cualquier motivo del periodo de la fecha selecionada",
                    value: parseInt(this.dataDashboard.total_refunds),
                    title: "Total Devolution"
                },
            ]
            const avg = this.dataDashboard.average || {}
            this.averages = [
                {
                    label: 'AVG_TOTAL',
                    title: `Average total $${avg.total}`,
                    averages: avg.total_daily
                },
                ...(avg.cv_daily && avg.cv_daily.length ? [{
                    label: 'AVG_CV',
                    title: `Average CV $${this.typeAverage('CV', avg.cv, avg.cv_daily, 'AVG_CV')}`,
                    averages: avg.cv_daily
                }] : []),
                ...(avg.fu_daily && avg.fu_daily.length ? [{
                    label: 'AVG_FU',
                    title: `Average FU $${this.typeAverage('F/U', avg.fu, avg.fu_daily, 'AVG_FU')}`,
                    averages: avg.fu_daily
                }] : []),
                ...(avg.pi_daily && avg.pi_daily.length ? [{
                    label: 'AVG_PI',
                    title: `Average PI $${this.typeAverage('P/I', avg.pi, avg.pi_daily, 'AVG_PI')}`,
                    averages: avg.pi_daily
                }] : []),
                ...(avg.pp_daily && avg.pp_daily.length ? [{
                    label: 'AVG_PP',
                    title: `Average PP $${this.typeAverage('P/P', avg.pp, avg.pp_daily, 'AVG_PP')}`,
                    averages: avg.pp_daily
                }] : []),
                ...(avg.rs_daily && avg.rs_daily.length ? [{
                    label: 'AVG_RS',
                    title: `Average RS $${this.typeAverage('R/S', avg.rs, avg.rs_daily, 'AVG_RS')}`,
                    averages: avg.rs_daily
                }] : []),
            ]
        }
    },
    computed: {
        byType() {
            return Array.isArray(this.dataDashboard?.average?.by_type)
                ? this.dataDashboard.average.by_type
                : []
        },
    },
    methods: {
        typeAverage(prefix, backendValue, dailyData, fieldName) {
            const row = (this.dataDashboard?.average?.by_type || []).find(
                item => item.prefix === prefix
            )
            if (row && row.average != null && row.average !== '') {
                return Math.trunc(Number(row.average) || 0)
            }
            if (backendValue != null && backendValue !== '') {
                return Math.trunc(Number(backendValue) || 0)
            }
            if (!dailyData || !dailyData.length) return 0
            const sum = dailyData.reduce(
                (acc, item) => acc + readDailyAverageValue(item, fieldName),
                0
            )
            return Math.round(sum / dailyData.length)
        },
        buscar(filtro) {
            this.fechas = {
                start: filtro.start,
                end: filtro.end
            }
            this.$emit('buscar', filtro)
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../assets/cssDashboards.css';
</style>
